import { Component, Input } from '@angular/core';

type button =
  | 'login'
  | 'landing'
  | 'landing-outline'
  | 'pill'
  | 'primary-solid'
  | 'primary-outline'
  | 'primary-text'
  | 'secondary-solid'
  | 'secondary-outline'
  | 'secondary-text'
  | 'danger-solid'
  | 'danger-outline'
  | 'danger-text'
  | 'cancel-solid'
  | 'cancel-outline'
  | 'cancel-text'
  | 'social-login';

@Component({
  standalone: false,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent {
  @Input() btnType: button;
  @Input() disabled = false;
  @Input() active = false;
  @Input() nav = false;
  @Input() subnav = false;
  @Input() small = false;
  @Input() icon = false;
  @Input() for = '';
}
